export default {
    'defaultLocale' : 'en-US',
    'availableLocales': ['en-US'],
    'serverLanguage': true,
}
